// Add only Portal 1 specific overrides here.
const tab1Module = {
  pages: {},
  components: {},
};

export default tab1Module;
